"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import { ChevronDown } from "lucide-react";
import InputField from "../ui/InputField";
import TextareaField from "../ui/TextareaField";
import Button from "../ui/buttons";
export default function CompanyForm() {
  const $ = _c(35);
  const [adsFor, setAdsFor] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [company, setCompany] = useState("");
  const [message, setMessage] = useState("");
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = e => setAdsFor(e.target.value);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <option value="" className=" text-14-tamil-300">Ads for</option>;
    t2 = <option value="print">Print Advertisement</option>;
    t3 = <option value="digital">Digital Advertisement</option>;
    t4 = <option value="print-digital">{"Print & Digital Combo"}</option>;
    t5 = <option value="classified">Classified Ad</option>;
    t6 = <option value="sponsorship">Sponsorship</option>;
    t7 = <option value="other">Other</option>;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t1 = $[1];
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
    t7 = $[7];
  }
  let t8;
  if ($[8] !== adsFor) {
    t8 = <select value={adsFor} onChange={t0} className="w-full h-[61px] px-4 py-2 border border-808080-300 focus:outline-none appearance-none bg-FFFFFF">{t1}{t2}{t3}{t4}{t5}{t6}{t7}</select>;
    $[8] = adsFor;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-808080-400"><ChevronDown className="h-4 w-4" /></div>;
    $[10] = t9;
  } else {
    t9 = $[10];
  }
  let t10;
  if ($[11] !== t8) {
    t10 = <div className="sm:flex-1 relative">{t8}{t9}</div>;
    $[11] = t8;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== name) {
    t11 = <InputField placeholder="Name" value={name} onChange={setName} className="sm:flex-1" height="61px" />;
    $[13] = name;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  let t12;
  if ($[15] !== t10 || $[16] !== t11) {
    t12 = <div className="flex flex-col sm:flex-row gap-4">{t10}{t11}</div>;
    $[15] = t10;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== email) {
    t13 = <InputField placeholder="Email Id" value={email} onChange={setEmail} className="sm:flex-1" height="61px" />;
    $[18] = email;
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] !== mobile) {
    t14 = <InputField placeholder="Mobile no." value={mobile} onChange={setMobile} className="sm:flex-1" height="61px" />;
    $[20] = mobile;
    $[21] = t14;
  } else {
    t14 = $[21];
  }
  let t15;
  if ($[22] !== t13 || $[23] !== t14) {
    t15 = <div className="flex flex-col sm:flex-row gap-4">{t13}{t14}</div>;
    $[22] = t13;
    $[23] = t14;
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] !== company) {
    t16 = <div><InputField placeholder="Your company name" value={company} onChange={setCompany} height="61px" /></div>;
    $[25] = company;
    $[26] = t16;
  } else {
    t16 = $[26];
  }
  let t17;
  if ($[27] !== message) {
    t17 = <div><TextareaField placeholder="Write your message" value={message} onChange={setMessage} height="132px" /></div>;
    $[27] = message;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <div className="pt-4"><Button variant="primary" onClick={_temp} className="cursor-pointer">அஞ்சல்</Button></div>;
    $[29] = t18;
  } else {
    t18 = $[29];
  }
  let t19;
  if ($[30] !== t12 || $[31] !== t15 || $[32] !== t16 || $[33] !== t17) {
    t19 = <div className="mx-auto bg-ECEEF3 w-full max-w-4xl lg:max-w-6xl xl:w-[1272px] xl:h-[501px] p-6"><div className="flex flex-col gap-4">{t12}{t15}{t16}{t17}{t18}</div> </div>;
    $[30] = t12;
    $[31] = t15;
    $[32] = t16;
    $[33] = t17;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  return t19;
}
function _temp() {}